// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.champion-display {
  background-color: #002129;
  max-width: 1000px;
  margin: 0 auto;
  padding: 16px;
}
.champion-display--mobile {
  padding: 16px 0px;
}

.champion-display-header {
  text-align: center;
  margin-bottom: 16px;
}
.champion-display-header__text {
  font-weight: 700 !important;
  color: #fff;
  font-size: 32px !important;
}
.champion-display-header__text--mobile {
  font-size: 14px !important;
}

.champion-display-body {
  display: flex;
  justify-content: center;
  width: 100%;
}

.champion-display-content {
  width: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.champion-display-image {
  width: 64px;
  height: 64px;
  object-fit: contain;
}
@media (max-width: 900px) {
  .champion-display-image {
    width: 32px;
    height: 40px;
  }
}

.champion-display-text {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 16px;
  color: #fff;
}
.champion-display-text__title {
  font-weight: 700 !important;
  white-space: nowrap;
  font-size: 48px !important;
}
.champion-display-text__title--mobile {
  font-size: 24px !important;
}
.champion-display-text__title--small-mobile {
  font-size: 18px !important;
}

.champion-display-footer {
  text-align: center;
  margin-top: 32px;
}
.champion-display-footer__text {
  font-weight: 700 !important;
  color: #fff;
  font-size: 32px !important;
}
.champion-display-footer__text--mobile {
  font-size: 14px !important;
}
@media (max-width: 900px) {
  .champion-display-footer {
    margin-top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ChampionDisplay/ChampDisplayTemplate.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AACJ;AACI;EACE,iBAAA;AACN;;AAGE;EACE,kBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,2BAAA;EACA,WAAA;EACA,0BAAA;AAAN;AAEM;EACE,0BAAA;AAAR;;AASE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AANJ;;AASE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AANJ;;AASE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AANJ;AAQI;EALF;IAMI,WAAA;IACA,YAAA;EALJ;AACF;;AASE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AANJ;AAQI;EACE,2BAAA;EACA,mBAAA;EACA,0BAAA;AANN;AAQM;EACE,0BAAA;AANR;AASM;EACE,0BAAA;AAPR;;AAYE;EACE,kBAAA;EACA,gBAAA;AATJ;AAWI;EACE,2BAAA;EACA,WAAA;EACA,0BAAA;AATN;AAWM;EACE,0BAAA;AATR;AAaI;EAdF;IAeI,aAAA;EAVJ;AACF","sourcesContent":[".champion-display {\n    background-color: #002129;\n    max-width: 1000px;\n    margin: 0 auto;\n    padding: 16px;\n  \n    &--mobile {\n      padding: 16px 0px;\n    }\n  }\n  \n  .champion-display-header {\n    text-align: center;\n    margin-bottom: 16px;\n  \n    &__text {\n      font-weight: 700 !important;\n      color: #fff;\n      font-size: 32px !important;\n  \n      &--mobile {\n        font-size: 14px !important;\n      }\n    }\n  \n    // @media (max-width: 900px) {\n    //   margin-bottom: 0; // Remove margin-bottom on screens smaller than 900px\n    // }\n  }\n  \n  .champion-display-body {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n  }\n  \n  .champion-display-content {\n    width: auto;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n  }\n  \n  .champion-display-image {\n    width: 64px;\n    height: 64px;\n    object-fit: contain;\n  \n    @media (max-width: 900px) {\n      width: 32px;\n      height: 40px;\n    }\n  }\n  \n  \n  .champion-display-text {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    margin: 0 16px;\n    color: #fff;\n  \n    &__title {\n      font-weight: 700 !important;\n      white-space: nowrap;\n      font-size: 48px !important;\n  \n      &--mobile {\n        font-size: 24px !important;\n      }\n  \n      &--small-mobile {\n        font-size: 18px !important;\n      }\n    }\n  }\n  \n  .champion-display-footer {\n    text-align: center;\n    margin-top: 32px;\n  \n    &__text {\n      font-weight: 700 !important;\n      color: #fff;\n      font-size: 32px !important;\n  \n      &--mobile {\n        font-size: 14px !important;\n      }\n    }\n  \n    @media (max-width: 900px) {\n      margin-top: 0; // Remove margin-top on screens smaller than 900px\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
